import StickerChallengeTable from './StickerChallengeTable';

export default StickerChallengeTable;
